import * as THREE from "three";
import {
  colors
} from "./colors.js";

export const settings = {
  models: [{
    file: '../../public/models/no-product.glb',
    sections: ['no-product']
  }],
  scale: 1, // Scale of model, adjust to size along with cameraDistance
  cameraDistance: 3,
  offsetHeight: -0.5,
  startingRotationY: 0, // degrees
  enabledShadows: true,
  shadowResolution: 2048, // 512, 1024, 2048
  clickFlashColor: 'f2ce2e', // f2ce2e
  colors: colors,
  environmentColor: 'f1f1f1',
  defaultColor: 'f1f1f1',
  floorColor: 'rgb(192, 192, 192)',
  minYRotate: 45, // degrees. 0 is top down
  maxYRotate: 90, // degrees. 90 is against the floor
  rotationDamping: true,
  enablePan: false,
  dampingFactor: 0.1,
  autoRotate: false,
  autoRotateSpeed: 0.2,
  showDragNotice: true,
  cameraFOV: 40,
  hemisphereLightColor: 'ffffff',
  hemisphereLightStrength: 0.61,
  directionalLightColor: 'ffffff',
  directionalLightStrength: 0.54,
  directionalLightPosition: {
    x: -8,
    y: 12,
    z: 8
  },
  uiParent: ".m3d-container",
  uiLoadingAnimation: ".m3d-loader__graphic", // Must be a class
  uiDragNotice: ".m3d-drag-notice",
  uiSwatchParent: ".m3d-tray-slide"
};